import ReactGA from "react-ga";
import { connect } from "react-redux";
import { confirmUser, logoutUser } from "actions/user";

import UserConfirmModal from "./UserConfirmModal";

const mapStateToProps = ({ currentUser, loading }) => ({
  currentUser,
  isSubmitting: loading.user,
});

const mapDispatchToProps = (dispatch) => ({
  onConfirm: (user) => {
    ReactGA.pageview("/confirm");

    return dispatch(confirmUser(user));
  },
  onCancel: (user) => dispatch(logoutUser(user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserConfirmModal);
